import React from "react";

function MountainIcon() {
  return (
    <svg width={28} height={28} viewBox="0 0 32 32" fill="none">
      <path d="M4 26L13 6L18 16L22 10L28 26H4Z" fill="var(--ac)" opacity=".2" />
      <path d="M4 26L13 6L18 16L22 10L28 26" stroke="var(--ac)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </svg>
  );
}

export default function Nav({ page, go }) {
  const links = [
    ["home", "Home"],
    ["guides", "Guides"],
    ["ranking", "Ranking"],
    ["quiz", "Quiz"],
  ];

  return (
    <nav>
      <div className="ni">
        <div className="nb" onClick={() => go({ t: "home" })}>
          <MountainIcon />
          <div>
            <div className="nbt">World Highpoint Guide</div>
            <div className="nbs">Every Country's Summit</div>
          </div>
        </div>
        <div className="nls">
          {links.map(([t, l]) => (
            <button key={t} className={`nl ${page.t === t ? "a" : ""}`} onClick={() => go({ t })}>
              {l}
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
}
